<template>
  <tbody>
    <tr>
      <td :style="{ backgroundColor: color}" class="resource-name resource-column operation column-left">
        <b-card :style="{ backgroundColor: color}" class="plan-title sub-card mb-0">
          <div class="d-flex align-items-center">
            <b-card-text :style="{ 'margin-left': '0.75em', 'min-width':'105px', 'padding-top': '6px' }"
                         class="d-flex align-items-center justify-content-between w-100 cursor-pointer"
                         @click="$emit('toggle')">
              <div class="tr-title d-flex align-items-center">{{ title }}</div>
              <b-icon-chevron-right v-if="!isVisible" aria-hidden="true" class="cursor-pointer"/>
              <b-icon-chevron-down v-if="isVisible" aria-hidden="true" class="cursor-pointer"/>
            </b-card-text>
          </div>
        </b-card>
      </td>
      <td
        v-for="period in periods"
        :key="getPeriodKey(period)"
        :class="{ 'current-month': isCurrentPeriod(period) }"
        :style="{ '--current-day-percentage': currentProgressPercentage() + '%' }"
        class="month"
      ></td>
    </tr>
  </tbody>
</template>

<script>
export default {
  props: {
    title: String,
    isVisible: Boolean,
    color: String,
  },
  computed: {
    periods() {
      return this.$parent.periods;
    },
  },
  methods: {
    getPeriodKey(period) {
      return this.$parent.getPeriodKey(period);
    },
    isCurrentPeriod(period) {
      return this.$parent.isCurrentPeriod(period);
    },
    isPastPeriod(period) {
      return this.$parent.isPastPeriod(period);
    },

    currentProgressPercentage(period) {
      return this.$parent.currentProgressPercentage(period);
    },
  },
};
</script>
<style scoped>
@import '../../assets/css/timeline.css';

.backwhite {
  background-color: #FFFFFF;
}

.tr-title {
  text-align: left;
  font-weight: 500;
  letter-spacing: 0px;
  color: #FFFFFF;
  opacity: 1;
}

svg[aria-label="chevron right"],
svg[aria-label="chevron down"] {
  color: #FFFFFF;
}

.legend-container {
  display: flex;
  justify-content: start;
  gap: 4em;
  margin-bottom: 1rem;
}

.legend-item {
  display: flex;
  align-items: center;
}

.legend-color {
  width: 28px;
  height: 18px;
  border-radius: 2px;
  margin-right: 1rem;
}

.legende-mail {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: var(--main-red);
  border: 2px solid var(--main-color);
  margin-right: 1rem;
  z-index: 1;
}

.legend-text {
  font-size: 14px;
}

.explication {
  color: var(--tertiary-text-color);
  font-size: 14px;
  font-family: "Montserrat-Regular", "Arial", sans-serif;
  display: flex;
  justify-content: start;
  align-items: center;
}

svg[aria-label="info circle"] {
  width: 1.25em;
  height: 1.25em;
  margin-right: 0.5em;
}

.toggle-sub-events-button {
  cursor: pointer;
  margin-left: 5px;
  transition: transform 0.3s;
}

.toggle-sub-events-button.rotated {
  transform: rotate(90deg);
}

.scale-selector {
  margin-bottom: 20px;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/operationPlanning/EventRow.vue